import { createTheme } from '@mui/material/styles'
import { ACCENT_BLUE, ACCENT_BLUE_HOVER } from './brand-colors'

export const theme = createTheme({
  palette: {
    primary: {
      main: ACCENT_BLUE,
      light: '#cfe8fc',
      dark: ACCENT_BLUE_HOVER,
    },
    secondary: {
      main: '#A0A0A0',
      light: '#EBEBEB',
    },
    success: {
      main: '#22E564',
      light: '#CFF2DC',
    },
    error: {
      main: '#E52222',
    },
    common: {
      white: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: ['"SF Pro Display"'].join(','),
    // MUI scales variants by fontSize/14; 14 matches sidebar scale (rail labels are 15px).
    fontSize: 14,
    body1: {
      fontSize: 15,
      lineHeight: 1.35,
      [`@media (max-width:600px)`]: {
        fontSize: 14,
        lineHeight: 1.35,
      },
    },
    subtitle1: {
      fontSize: 15,
      lineHeight: 1.4,
    },
    h6: {
      fontSize: 17,
      lineHeight: 1.35,
    },
    h5: {
      fontSize: 18,
      lineHeight: 1.35,
    },
    button: {
      fontSize: 14,
      lineHeight: 1.35,
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontSize: '0.875rem',
          fontWeight: 600,
        },
        sizeLarge: {
          fontSize: '0.9375rem',
        },
        sizeSmall: {
          fontSize: '0.8125rem',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          fontSize: '0.9375rem',
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        input: {
          fontSize: '0.9375rem',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          fontWeight: 600,
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,

            span: {
              fontWeight: 700,
            },
          },
          '&.Mui-selected:hover': {
            backgroundColor: theme.palette.primary.dark,

            span: {
              fontWeight: 700,
            },
          },
        }),
      },
    },
  },
})
